.container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    border: 1px dashed var(--sentiment-background-info);
    border-radius: 0.5rem;
    background-color: var(--static-background-strong);
}

.logoSection {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.logoContainer {
    padding-right: 2rem;
    display: flex;
    border-right: 1px solid var(--static-divider-standard);
}

.logo {
    height: 2rem;
    width: auto;
}

.statusBadge {
    font-size: var(--fs-normal);
    color: var(--static-text-standard);
    background-color: var(--sentiment-background-neutral);
    padding: 0 0.375rem;
    border-radius: 0.375rem;
    font-weight: 600;
    line-height: normal;
}

.statusActive {
    background-color: var(--sentiment-background-positive);
    color: var(--sentiment-text-positive);
}

.contentSection {
    flex: 1;
    padding-left: 1rem;
    border-left: 1px solid var(--static-divider-standard);
    margin-left: 0.75rem;
}

.consentText {
    color: var(--static-text-weak);
    font-size: var(--fs-small);
    font-weight: 400;
    line-height: normal;
}

.dataSection {
    display: flex;
    align-items: center;
    margin-top: 0.25rem;
}

.dataLabel {
    font-weight: 500;
}

.dataItem {
    display: flex;
    align-items: center;
    margin-left: 1rem;
}

.dataDot {
    width: 0.75rem;
    height: 0.75rem;
    background-color: var(--sentiment-text-info);
    border-radius: 50%;
    margin-right: 0.5rem;
}

.dataLink {
    color: var(--sentiment-text-info);
    font-weight: 500;
    text-decoration: none;
}

.dataLink:hover {
    text-decoration: underline;
}

.toggleSection {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-direction: column;
}

.toggleLabel {
    font-weight: 500;
    color: var(--static-text-strong);
    font-size: 16px;
    font-style: normal
}

.toggleButton {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 2.75rem;
    height: 1.5rem;
    border-radius: 9999px;
    background-color: var(--static-text-weak);
    transition: background-color 0.2s;
    border: none;
    cursor: pointer;
}

.toggleActive {
    background-color: var(--primary-enabled);
}

.toggleThumb {
    position: absolute;
    left: 0.25rem;
    display: block;
    width: 1rem;
    height: 1rem;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.2s;
}

.toggleThumbActive {
    transform: translateX(1.25rem);
}

.toggleSpinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    --color-primary: var(--primary-enabled);
}

.toggleActive .toggleSpinner {
    --color-primary: var(--static-background-strong);
}

.toggleButton:disabled {
    cursor: not-allowed;
}

.primaryButton {
    background-color: var(--primary-enabled);
    color: var(--static-background-strong);
    border: none;
    border-radius: 0.375rem;
    padding: 0.5rem 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    width: 120px;
}

.primaryButton:hover {
    background-color: var(--primary-hover);
}

.primaryButton:disabled {
    background-color: var(--static-text-weak);
    cursor: not-allowed;
}

.walmartButton {
    background-color: transparent;
    color: var(--static-text-standard);
    border: 1px solid var(--static-divider-standard);
    border-radius: 0.375rem;
    padding: 0.5rem 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: var(--fs-small);
    width: 120px;
    justify-content: center;
}

.walmartButton:hover {
    background-color: var(--static-background-weak);
    border-color: var(--static-text-weak);
}

.modalBodyText {
    margin: 20px;
}
